import {
  routes as home
} from '../views/home'
import {
  routes as auth
} from '../modules/auth'
import {
  routes as units
} from '@/views/units'
import {
  routes as showClass
} from '@/views/show-class'
export default [
  ...auth,
  ...home,
  ...showClass,
  ...units,


]